import React from 'react';
import AddDeductionModal from './add-deduction-modal.component';
import CalculationBreakdownModal from './calculation-breakdown-modal.component';
import ExpressPaymentModal from './express-payment-modal.component';
import { UseFormRegister, UseFormSetValue, UseFormWatch, FieldErrors, UseFormTrigger } from 'react-hook-form';

interface InvoiceModalsProps {
  showDeductionModal: boolean;
  showCalculationModal: boolean;
  showExpressPaymentModal: boolean;
  handleCloseDeductionModal: () => void;
  handleDeductionSubmit: (data: any) => Promise<void>;
  setShowCalculationModal: (value: boolean) => void;
  setCalculationBreakdownData: (value: any) => void;
  setShowExpressPaymentModal: (value: boolean) => void;
  handleExpressPaymentModalConfirm: () => void;
  handleExpressPaymentModalReject?: () => void;
  expressModalMode?: 'info' | 'confirm';
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  errors: FieldErrors<any>;
  trigger: UseFormTrigger<any>;
  t: any;
  editingDeductionData: any;
  copiedInvoiceData: any;
  calculationBreakdownData: any;
  currency: string;
  calculatedSubAmount: any;
  preferences?: any;
  currencyRate?: number;
}

export const InvoiceModals: React.FC<InvoiceModalsProps> = ({
  showDeductionModal,
  showCalculationModal,
  showExpressPaymentModal,
  handleCloseDeductionModal,
  handleDeductionSubmit,
  setShowCalculationModal,
  setCalculationBreakdownData,
  setShowExpressPaymentModal,
  handleExpressPaymentModalConfirm,
  handleExpressPaymentModalReject,
  expressModalMode,
  register,
  setValue,
  watch,
  errors,
  trigger,
  t,
  editingDeductionData,
  copiedInvoiceData,
  calculationBreakdownData,
  currency,
  calculatedSubAmount,
  preferences,
  currencyRate,
}) => {
  return (
    <>
      <AddDeductionModal
        isOpen={showDeductionModal}
        onClose={handleCloseDeductionModal}
        onSubmit={handleDeductionSubmit}
        register={register}
        setValue={setValue}
        watch={watch}
        errors={errors}
        trigger={trigger}
        t={t}
        editingDeductionData={editingDeductionData}
        copiedInvoiceData={copiedInvoiceData}
        preferences={preferences}
        currencyRate={currencyRate}
      />
      
      <CalculationBreakdownModal
        isOpen={showCalculationModal}
        onClose={() => {
          setShowCalculationModal(false);
          setCalculationBreakdownData(null);
        }}
        calculationData={calculationBreakdownData}
        currency={currency}
      />

      <ExpressPaymentModal
        isOpen={showExpressPaymentModal}
        onClose={() => setShowExpressPaymentModal(false)}
        onConfirm={handleExpressPaymentModalConfirm}
        onReject={handleExpressPaymentModalReject}
        mode={expressModalMode}
        calculatedAmount={calculatedSubAmount?.response?.totalCalculation?.amountIncludingVat || 0}
        currency={currency}
      />
    </>
  );
};
